/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_Document_ActionInputs */

const cs_templates_ai_document_action = /** @type {(inputs: Templates_Ai_Document_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybrat soubor…`)
};

const en_templates_ai_document_action = /** @type {(inputs: Templates_Ai_Document_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose file…`)
};

/**
* | output |
* | --- |
* | "Choose file…" |
*
* @param {Templates_Ai_Document_ActionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_document_action = /** @type {((inputs?: Templates_Ai_Document_ActionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_Document_ActionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_document_action(inputs)
	return cs_templates_ai_document_action(inputs)
});